import api from '../configs/api.config';
import { downloadBlob } from '../helpers/utils';
import { WEFResponse } from '../Types';
import {
  TicketOutcomeReportRequest,
  TicketOutcomeReportResponse
} from '../types/ticketOutcomeReport.types';

export const getTicketOutcomes = async (
  request: TicketOutcomeReportRequest
): Promise<TicketOutcomeReportResponse> => {
  const { data } = await api.post<WEFResponse<TicketOutcomeReportResponse>>(
    '/Analytics/ticket-outcomes',
    request
  );
  return data.data;
};

export const exportTicketOutcomes = async (request: TicketOutcomeReportRequest): Promise<void> => {
  const response = await api.post('/Analytics/ticket-outcomes/export', request, {
    responseType: 'blob'
  });

  const fileName = `TicketOutcomes_${request.startDate}_to_${request.endDate}.csv`;
  downloadBlob(response.data, fileName);
};
